import { ComponentProps, forwardRef } from "react"

import Link from "@/common/vite-shims/next/link"

// Wrapper component over the React Router-backed Link shim. Consumers import
// from here (or `@/common/navigation`) — never the shim directly.
const NavigationLink = forwardRef<HTMLAnchorElement, ComponentProps<typeof Link>>((props, ref) => {
  return <Link ref={ref} {...props} />
})

NavigationLink.displayName = "NavigationLink"

export default NavigationLink

// Re-export for convenience
export { default as NextLink } from "@/common/vite-shims/next/link"
